import { setField } from "Utils/formUtils";
import { FormikProps } from "formik";
import { CarProductIntroFormValues } from "../interfaces";

export function resetVehicle(
  formProps: FormikProps<CarProductIntroFormValues>,
): void {
  setField(formProps, "licensePlateNumberSelected", "");

  setField(formProps, "brand", undefined, false);
  setField(formProps, "canBeBoughtOnline", undefined, false);
  setField(formProps, "configurationId", undefined, false);
  setField(formProps, "isAlreadyInsured", undefined, false);
  setField(formProps, "kw", undefined, false);
  setField(formProps, "licensePlateNumber", "", false);
  setField(formProps, "licensePlateNumberSearch", "", false);
  setField(formProps, "model", undefined, false);
  setField(formProps, "modelType", undefined, false);
  setField(formProps, "tfaCode", undefined, false);
  setField(formProps, "type", undefined, false);
  setField(formProps, "volume", undefined, false);
  setField(formProps, "warrantyType", undefined, false);
  setField(formProps, "year", undefined, false);
}
